import { useApolloClient } from '@apollo/react-hooks';
import gql from 'not-graphql-tag';
import {
  StopSubmitRequestInput,
  StopSubmitRequestResponse,
} from '../__generated__/pge-types';

const stopServiceMutation = gql`
  mutation StopServiceSubmitRequest($payload: StopSubmitRequestInput!) {
    stopServiceSubmitRequest(payload: $payload) {
      isSucessfull
    }
  }
`;

export function useSSMStopSubmit() {
  const apolloClient = useApolloClient();
  async function submit(payload: StopSubmitRequestInput) {
    const result = await apolloClient.mutate<{
      stopServiceSubmitRequest: StopSubmitRequestResponse;
    }>({
      mutation: stopServiceMutation,
      variables: {
        payload,
      },
    });
    return result;
  }

  return { submit };
}
